import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, } from "@nextui-org/react";
import { useAuth, useFirestore, useFirestoreCollectionData, useUser } from "reactfire";
import { collection, where, query, getDocs, onSnapshot, orderBy } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { NewGenerator } from "./newGenerator";
import { useEffect, useState } from "react";

const Generators = () => {
    const navigate = useNavigate(); 
    const firestore = useFirestore();
    const auth = useAuth(); 

    const [generators, setGenerators] = useState<any>(); 

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });

    
    useEffect(()=>{
        const fetchData = async () => {
            
            if (auth.currentUser) {
                const q = query(collection(firestore, "generators"), where("createdBy", "==", auth.currentUser?.uid), orderBy('lastUpdated', 'desc'));

                const unsubscribe = onSnapshot(q, (querySnapshot) => {
                    const docs:Array<any> = [];
                    querySnapshot.forEach((doc) => {
                        docs.push({ ...doc.data(), id: doc.id });
                    });
                    setGenerators(docs);
                });
            }
        }
        fetchData(); 
    }, []);
    
    return (
        <>
            <div className="flex justify-between">
                <div className="text-2xl font-bold">Generators</div>
                <NewGenerator />
            </div>
            <br></br>
            <Table
                aria-label="Generators"
                selectionMode="single"
            >
                <TableHeader>
                    <TableColumn>Name</TableColumn>
                    <TableColumn>Description</TableColumn>
                    <TableColumn>Created By</TableColumn>
                    <TableColumn>Last Updated</TableColumn>
                </TableHeader>
                <TableBody 
                    emptyContent={"No rows to display"}>
                    {generators?.map((generator: any) => (
                        //TODO: paginated table 
                        
                        <TableRow key={generator.id} onClick={()=>navigate(`/generators/${generator.id}`)}>
                            <TableCell>{generator.name}</TableCell>
                            <TableCell>{generator.description}</TableCell>
                            <TableCell>{generator.createdByName}</TableCell>
                            <TableCell>{dateFormatter.format(new Date(generator.lastUpdated))}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    )
}


export default Generators; 